/*
 * author kcz
 * date 2019-11-20
 * description 表单控件项
 */
// 请求接口
const list = [
  //检测信息配置
  //检测仪器1
  {
    "type": "VERTICAL",
    "label": "模板一",
     "rows":[ 
    {
      "cells" : [ {
        "paramId" : 1,
        "componentKey" : "template.org_name",
        "componentName" : "",
        "showName" : "",
        "resultLine" : null,
        "resultKey" : "",
        "extParamType" : "",
        "extParamDataType" : "",
        "extParamUnit" : null,
        "extParamDictType" : null,
        "width" : 10772,
        "height" : 340,
        "rowLine" : null
      } ]
    }, 
    {
      "cells" : [ {
        "paramId" : 2,
        "componentKey" : "template.title",
        "componentName" : "主标题",
        "showName" : "$",
        "resultLine" : null,
        "resultKey" : "template.templateName",
        "extParamType" : "19",
        "extParamDataType" : "3",
        "extParamUnit" : null,
        "extParamDictType" : null,
        "width" : 10772,
        "height" : 510,
        "rowLine" : null
      } ]
    }, 
    {
      "cells" : [ {
        "paramId" : 3,
        "componentKey" : "tempate.controller_num",
        "componentName" : "受控号",
        "showName" : "$",
        "resultLine" : null,
        "resultKey" : "template.controllerNum",
        "extParamType" : "19",
        "extParamDataType" : "3",
        "extParamUnit" : null,
        "extParamDictType" : null,
        "width" : 5386,
        "height" : 510,
        "rowLine" : null
      }, 
      {
        "paramId" : 4,
        "componentKey" : "template.page_num",
        "componentName" : "页码",
        "showName" : "第$页共$页",
        "resultLine" : null,
        "resultKey" : "template.pageNum,template.pageTotal",
        "extParamType" : "19",
        "extParamDataType" : "1,1",
        "extParamUnit" : null,
        "extParamDictType" : null,
        "width" : 5386,
        "height" : 510,
        "rowLine" : null
      } ]
    }
    ],
     "main":[ {
      "cells" : [ {
        "paramId" : 5,
        "componentKey" : "signature.check",
        "componentName" : "检验者",
        "showName" : "检验者$",
        "resultLine" : null,
        "resultKey" : "signature.check",
        "extParamType" : "18",
        "extParamDataType" : "3",
        "extParamUnit" : null,
        "extParamDictType" : null,
        "width" : 2693,
        "height" : 510,
        "rowLine" : null
      }, {
        "paramId" : 6,
        "componentKey" : "signature.checkDate",
        "componentName" : "检验日期",
        "showName" : "日期$",
        "resultLine" : null,
        "resultKey" : "signature.checkDate",
        "extParamType" : "18",
        "extParamDataType" : null,
        "extParamUnit" : null,
        "extParamDictType" : null,
        "width" : 2693,
        "height" : 510,
        "rowLine" : null
      }, {
        "paramId" : 7,
        "componentKey" : "signature.verification",
        "componentName" : "核验者",
        "showName" : "校核者$",
        "resultLine" : null,
        "resultKey" : "signature.verification",
        "extParamType" : "18",
        "extParamDataType" : null,
        "extParamUnit" : null,
        "extParamDictType" : null,
        "width" : 2693,
        "height" : 510,
        "rowLine" : null
      }, {
        "paramId" : 8,
        "componentKey" : "signature.verificationDate",
        "componentName" : "核验日期",
        "showName" : "日期$",
        "resultLine" : null,
        "resultKey" : "signature.verificationDate",
        "extParamType" : "18",
        "extParamDataType" : null,
        "extParamUnit" : null,
        "extParamDictType" : null,
        "width" : 2693,
        "height" : 510,
        "rowLine" : null
      } ]
    } ],
  } ,
]
// 内置控件
export const defaultSchemaList = list
